export const OPERATIONS_DOMAINS = ['checkout', 'opening'] as const

/** Boutiques maximum par abonnement `operations:subscribe` ; au-delà, le serveur refuse l'abonnement. */
export const MAX_OPERATIONS_STORES = 100

export type OperationsDomain = (typeof OPERATIONS_DOMAINS)[number]

export interface OperationsSubscription {
  storeIds: number[]
  domains: OperationsDomain[]
}

export type OperationsSubscriptionError = 'internal-error' | 'invalid-payload' | 'too-many-stores'

export interface OperationsSubscriptionAck {
  subscribedStoreIds: number[]
  rejectedStoreIds: number[]
  error?: OperationsSubscriptionError
}

export const CHECKOUT_UPDATE_REASONS = [
  'computed',
  'validated',
  'cancelled',
  'stolen',
  'paid',
  'manual-mode',
  'kiosk-sync',
] as const

export type CheckoutUpdateReason = (typeof CHECKOUT_UPDATE_REASONS)[number]

export interface CheckoutUpdatedEvent {
  storeId: number
  kioskId: number | null
  cartId: number | null
  reason: CheckoutUpdateReason
  occurredAt: string
}

export interface OpeningEventUpdatedEvent {
  storeId: number
  occurredAt: string
}

export interface OperationsServerToClientEvents {
  'checkout:updated': (event: CheckoutUpdatedEvent) => void
  'opening-event-updated': (event: OpeningEventUpdatedEvent) => void
}

export interface OperationsClientToServerEvents {
  'operations:subscribe': (
    subscription: OperationsSubscription,
    acknowledge: (ack: OperationsSubscriptionAck) => void,
  ) => void
  'operations:unsubscribe': (
    subscription: OperationsSubscription,
    acknowledge: (ack: OperationsSubscriptionAck) => void,
  ) => void
}
